module.exports = __webpack_public_path__ + "static/media/img-company-success-1-mobile@3x.c92d0368.png";